export default "__VITE_ASSET__DdomxzMW__"